import { Alert, EAlertVariant, GeneralMapPinOutlineIcon } from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';

import { useBreakpoint } from '@/hooks/useBreakpoint';

const LocationNotice: React.FC = () => {
  const intl = useIntl();
  const { isMobile } = useBreakpoint();

  return (
    <div className="px-4 pt-5 md:pb-0 md:px-5">
      <Alert
        variant={EAlertVariant.Info}
        content={intl.formatMessage({
          defaultMessage:
            'The easiest way to RV: delivery with full set-up. Enter a destination address to see rigs you can stay in, without having to drive or tow.',
          id: 'kbnAcO',
        })}
        customIcon={isMobile ? undefined : GeneralMapPinOutlineIcon}
      />
    </div>
  );
};

export default LocationNotice;
